import { Component } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { environment } from '../../../../environments/environment';
import { CommonModule } from '@angular/common';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  imports: [
    CommonModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
  ],
  selector: 'app-navbar',
  styleUrls: ['./navbar.scss'],
  templateUrl: './navbar.html',
})
export class Navbar {
  appTitle = 'Catena-X Mapping';
  environmentSuffix = '';

  constructor(private authService: AuthService) { }

  ngOnInit(): void {
    // Set environment suffix for display in the navbar
    if (environment.stage && environment.stage !== 'prod') {
      this.environmentSuffix = ` (${environment.stage.toUpperCase()})`;
    }
  }


  logout() {
    this.authService.signOut();
  }
}
